import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { useLockBodyScroll } from '../../hooks/helpers/useLockBodyScroll';
import { Backdrop } from './Backdrop';
import { Dialog } from './Dialog';
import { Portal } from './Portal';
import { DrawerProps } from './types';
import { DrawerElement } from './Drawer.style';
import { DrawerProvider } from './DrawerProvider';

const Drawer = ({
  id = 'drawer-root',
  open = false,
  children,
  onClose,
  ...props
}: DrawerProps): JSX.Element => {
  useLockBodyScroll(open);

  return (
    <DrawerProvider open={open} onClose={onClose}>
      <AnimatePresence>
        {open && (
          <Portal id={id}>
            <DrawerElement>
              <Backdrop {...props}>
                <Dialog>{children}</Dialog>
              </Backdrop>
            </DrawerElement>
          </Portal>
        )}
      </AnimatePresence>
    </DrawerProvider>
  );
};

export { Drawer };
